import { render, staticRenderFns } from "./case-list.html?vue&type=template&id=2df054de&scoped=true&"
import script from "./case-list.js?vue&type=script&lang=js&"
export * from "./case-list.js?vue&type=script&lang=js&"
import style0 from "./case-list.scss?vue&type=style&index=0&id=2df054de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df054de",
  null
  
)

export default component.exports